import { of } from 'rxjs';
import UserApi from '../api/UserApi';
import UserConstants from '../constants/UserConstants';

function fetchUser(userId) {
  return {
    types: [UserConstants.FETCH_USER_REQUEST, UserConstants.FETCH_USER_SUCCESS, UserConstants.FETCH_USER_ERROR],
    apiRequest: (state, client) => {
      if (!userId) {
        return of({ user: null });
      }

      return UserApi.fetchUser({ userId }, client);
    }
  };
}

export default {
  fetchUser
};
